/**
 * v2 Auth サーバ（NEXT_PUBLIC_AUTH_V2_URL）向けのエンドポイントヘルパー。
 * httpOnly Cookie を使用するため、fetch 時に credentials: 'include' が必要。
 */
export const authV2Url = {
  /**
   * GET /{campaignSlug}/auth/check
   * 認証状態確認・IdToken 取得
   */
  check: (campaignSlug: string) => `${process.env.NEXT_PUBLIC_AUTH_V2_URL}/${campaignSlug}/auth/check`,
  /**
   * POST /{campaignSlug}/token/refresh
   * IdToken / AccessToken の更新（リクエストボディ不要・Cookie の RefreshToken を使用）
   */
  tokenRefresh: (campaignSlug: string) => `${process.env.NEXT_PUBLIC_AUTH_V2_URL}/${campaignSlug}/token/refresh`,
  /**
   * POST /{campaignSlug}/auth/logout
   * ログアウト（httpOnly Cookie 削除・セッション破棄）
   */
  logout: (campaignSlug: string) => `${process.env.NEXT_PUBLIC_AUTH_V2_URL}/${campaignSlug}/auth/logout`,
  /**
   * GET /{campaignSlug}/line/authorize/force-friend
   * LINE友達追加強制リダイレクト先（LINE未友達ユーザを誘導するための authサーバエンドポイント）
   */
  forceFriendAdd: (campaignSlug: string) =>
    `${process.env.NEXT_PUBLIC_AUTH_V2_URL}/${campaignSlug}/line/authorize/force-friend`,
}
